export const INIT_HIGHSTATE = "INIT_HIGHSTATE";
export const INIT_HIGHSTATE_RETURN = "INIT_HIGHSTATE_RETURN";
export const CHECKING_HIGHSTATE = "CHECKING_HIGHSTATE";
export const HIGHSTATE_UPDATE = "HIGHSTATE_UPDATE";
export const HIGHSTATE_REQUEST_FAILED = "HIGHSTATE_REQUEST_FAILED";

export function startHighstate(serialNum) {
  return {
    type: INIT_HIGHSTATE,
    meta: {
      endpoint: "/installer/softwareinstall",
      method: "POST",
      body: {
        serialNum: serialNum,
      },
      success: startHighstateSuccess,
    },
  };
}

function startHighstateSuccess(response) {
  return {
    type: INIT_HIGHSTATE_RETURN,
    payload: {
      ...response,
    },
  };
}

export function checkHighstate(serialNum, jid) {
  return {
    type: CHECKING_HIGHSTATE,
    meta: {
      endpoint:
        "/installer/softwareinstall?serial_number=" + serialNum + "&jid=" + jid,
      success: checkHighstateSuccess,
      error: checkHighstateFailure,
    },
  };
}

function checkHighstateFailure() {
  return {
    type: HIGHSTATE_REQUEST_FAILED,
  };
}

function checkHighstateSuccess(response) {
  return {
    type: HIGHSTATE_UPDATE,
    payload: {
      ...response,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/highstate.js